import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { SelectedZoneSchema } from "./add-redo-carrier-service";

// Starts the setupLandedCostDemoCheckoutTree Temporal workflow (sync metafields
// → create experiences → wrap tree → add carrier service). Returns immediately;
// poll getSetupLandedCostDemoCheckoutTreeStatus for completion.
export const setupLandedCostDemoCheckoutTree = {
  name: "setupLandedCostDemoCheckoutTree" as const,
  input: z.object({
    teamId: zExt.objectId(),
    selectedZones: z.array(SelectedZoneSchema),
  }),
  output: z.null(),
};

// `shopifyCheckoutEditorUrl` deep links the merchant into Shopify's checkout
// editor, where the Redo shipping-option extension must be activated by hand.
export const getSetupLandedCostDemoCheckoutTreeStatus = {
  name: "getSetupLandedCostDemoCheckoutTreeStatus" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    isRunning: z.boolean(),
    failed: z.boolean(),
    shopifyCheckoutEditorUrl: z.string().optional(),
    // Zones the run rejected. A run that rejected every zone reports `failed`.
    errors: z.array(z.string()),
  }),
};
